import React from 'react';

// Like a 404 page, but for React.
function UnknownRoute(props) {
  return <div>Unknown route: {props.location.pathname}</div>;
}

export default UnknownRoute;
